import * as React from 'react'
import {
  WithStyles,
  createStyles,
  Snackbar,
  SnackbarContent,
  IconButton
} from '@material-ui/core'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import withStyles from '@material-ui/core/styles/withStyles'
import CloseIcon from '@material-ui/icons/Close'
import ErrorIcon from '@material-ui/icons/Error'

interface IErrorMessageProps extends WithStyles<typeof styles> {
  messages: string[]
  onClose: () => void
}

interface IErrorMessageState {
  open: boolean
}

class ErrorMessage extends React.PureComponent<
  IErrorMessageProps,
  IErrorMessageState
> {
  public readonly state: IErrorMessageState = {
    open: true
  }

  public render() {
    const { classes, messages } = this.props
    const { open } = this.state

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={open}
        onClose={this.handleClose}>
        <SnackbarContent
          className={classes.error}
          message={messages.map((message, i) => (
            <div key={i} className={classes.message}>
              <ErrorIcon className={classes.errorIcon} />
              {message}
            </div>
          ))}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.forwardClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          ]}
        />
      </Snackbar>
    )
  }

  private forwardClose = (e: any) => {
    this.handleClose(e)
  }

  private handleClose = (e: any, reason: string = '') => {
    if (reason !== 'clickaway') {
      this.setState({ open: false })
      this.props.onClose()
    }
  }
}

const styles = (theme: Theme) =>
  createStyles({
    error: {
      alignItems: 'flex-start',
      backgroundColor: theme.palette.error.main,
      color: '#fff'
    },
    errorIcon: {
      fontSize: 20,
      marginRight: theme.spacing.unit
    },
    closeIcon: {
      fontSize: 20
    },
    message: {
      alignItems: 'center',
      display: 'flex',
      margin: theme.spacing.unit,
      width: '80%'
    }
  })

export default withStyles(styles)(ErrorMessage)



// WEBPACK FOOTER //
// ./src/components/shared/ErrorMessage.tsx